export interface IRelativePerformance {
    centerId: number,
    centerAlias: string,
    compositeScore: IRpCompositeScore,
    preselectsAveragePercentReviewedThisMonth: IRpPreselectsAveragePercentReviewedThisMonth,
    surgeryDateDecline: IRpSurgeryDateDecline,
    swapFailureRate: IRpSwapFailureRate,
    chainEndDeclineRatio: IRpChainEndDeclineRatio,
    nkrDonorReferralConversionRate: IRpNkrDonorReferralConversionRate,
    nkrDonorReferralMedianContactTime: IRpNkrDonorReferralMedianContactTime,
    micrositePatientReferralSuccessRate: IRpMicrositePatientReferralSuccessRate,
    missedMatchOfferDeadline: IRpMissedMatchOfferDeadline,
    svDonations: IRpSvDonations,
    fvDonations: IRpFvDonations,
    kflSuccessRate: IRpKflSuccessRate,
    micrositeEnrollmentRate: IRpMicrositeEnrollmentRate,
    voucherDisconnect: IRpVoucherDisconnect,
    privateLabelVoucherDisconnect: IRpVoucherDisconnect,
    combinedVoucherDisconnect: IRpVoucherDisconnect,
    fiveStarSurveyResults: IRpFiveStarSurveyResults,
    cprScore: IRpCprScore,
    overallPerformance: IRpOverallPerformance
}

export interface IRpCompositeScore {
    rank: number,
    compositeScore: number,
    category: string
}

export interface IRpPreselectsAveragePercentReviewedThisMonth {
    rank: number,
    average: number,
    category: string
}

export interface IRpSurgeryDateDecline {
    rank: number,
    declineCount: number,
    offerCount: number,
    declineRate: number,
    category: string
}

export interface IRpSwapFailureRate {
    rank: number,
    failures: number,
    covidFailures: number,
    totalTransplants: number
    failureRate: number,
    category: string
}

export interface IRpChainEndDeclineRatio {
    rank: number,
    declines: number,
    starts: number,
    wlpOffers: number,
    wlpDeclines: number,
    declineRatio: number,
    category: string
}

export interface IRpNkrDonorReferralMedianContactTime {
    rank: number,
    referralCount: number,
    contactTimeDaysMedian: number,
    category: string
}

export interface IRpNkrDonorReferralConversionRate {
    rank: number,
    donatedCount: number,
    referralCount: number,
    conversionRate: number,
    category: string
}

export interface IRpMicrositePatientReferralSuccessRate {
    rank: number,
    micrositeCount: number,
    referralCount: number,
    conversionRate: number,
    isParticipant: boolean,
    category: string
}

export interface IRpMissedMatchOfferDeadline {
    rank: number,
    matchOfferCount: number,
    missedDeadlineCount: number,
    ratio: number,
    category: string
}

export interface IRpSvDonations {
    rank: number,
    totalStandardVouchers: number,
    totalDonations: number,
    category: string
}

export interface IRpFvDonations {
    rank: number,
    totalFamilyVouchers: number,
    totalDonations: number,
    category: string
}

export interface IRpKflSuccessRate {
    rank: number,
    lowEpletTxpCount: number,
    txpRecipient3GTypingCount: number,
    kidneyForLifeSuccessRate: number,
    isParticipant: boolean,
    category: string
}

export interface IRpMicrositeEnrollmentRate {
    rank: number,
    activeMicrositeCount: number,
    waitlistCount: number,
    micrositeEnrollmentRate: number,
    isParticipant: boolean,
    category: string
}

export interface IRpVoucherDisconnect {
    rank: number,
    disconnects: number,
    totalDonations: number,
    percentDisconnect: number,
    category: string
}

export interface IRpFiveStarSurveyResults {
    rank: number,
    average: number,
    networkAverage: number,
    comparison: number,
    scoreNumerator: number,
    scoreDenominator: number,
    category: string
}

export interface IRpCprScore {
    rank: number,
    compatiblePairs: number,
    transplants: number,
    cprScore: number,
    category: string
}

export interface IRpOverallPerformance {
    rank: number,
    rankSum: number
}
